import React from 'react';
import { useFormContext } from 'react-hook-form';

import {
  Input,
  Range,
  Radio,
  Paragraph,
  Checkbox,
  Message,
  ThankYouMessage,
} from '../survey-questions-builder/question/question-types';
import { OPTION_TYPES } from '../../constants';
import QuestionTitleEditor from '../survey-questions-builder/question/question-title-editor';
import { convertQuillHTMLToText } from 'shared/utils';

const questionTypes: any = {
  [OPTION_TYPES.INPUT]: Input,
  [OPTION_TYPES.CHECKBOX]: Checkbox,
  [OPTION_TYPES.PARAGRAPH]: Paragraph,
  [OPTION_TYPES.DROPDOWN]: Radio,
  [OPTION_TYPES.MESSAGE]: Message,
  RANGE: Range,
  open: Boolean,
  THANKYOU: ThankYouMessage,
};

export type QuestionProps = {
  open: boolean;
  surveyForm: any;
  setSurveyForm?: Function;
  readOnly?: any;
  thankYouMessage?: boolean;
  blockQuestionIndex: number;
  activeQuestion: number;
  block: any;
  blocks: any;
  disabled?: any;
};

const Question = ({
  thankYouMessage,
  open,
  disabled,
  blockQuestionIndex,
  setSurveyForm,
  surveyForm,
  block,
  blocks,
  readOnly,
  activeQuestion,
}: QuestionProps) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const blockQuestion =
    surveyForm.question_details?.questions?.[blockQuestionIndex];

  const QuestionType = thankYouMessage
    ? questionTypes.THANKYOU
    : questionTypes[blockQuestion?.type_info.question_type];

  const watchQuestions = surveyForm.question_details.questions || [];
  // const [edit, setEdit] = React.useState(false)

  const question = watchQuestions?.find(
    (question: any) =>
      question.name ===
      ((block?.question_names && block?.question_names[activeQuestion]) ||
        block?.question_name),
  );

  // console.log(
  //   'activeQuestion',
  //   watchQuestions,
  //   blockQuestionIndex,
  //   activeQuestion,
  //   question,
  // );

  if (!question) return null;

  const setQuestion = (key: string, value: any) => {
    setSurveyForm &&
      !disabled &&
      setSurveyForm({
        ...surveyForm,
        question_details: {
          ...surveyForm.question_details,
          questions: watchQuestions?.map((q: any) =>
            q.name === question.name ? { ...q, [key]: value } : q,
          ),
        },
      });
  };

  const questionIndex = watchQuestions?.findIndex(
    (q: any) => q.name === question.name,
  );

  return (
    <div className={`${open ? 'open' : ''} question-container`}>
      {readOnly || (block.name !== 'TY' && disabled) || !open ? (
        <div className="text-lg">{question?.text}</div>
      ) : block?.type === 'MESSAGE' || block.name === 'TY' ? null : (
        <QuestionTitleEditor
          open={open}
          body={question.text}
          questionIndex={questionIndex}
          questionType={question.type_info.question_type}
        />
      )}

      {open && (
        <QuestionType
          surveyForm={surveyForm}
          question={question}
          block={block}
          disabled={disabled}
          blockQuestion={blockQuestion}
          questionIndex={questionIndex}
          control={control}
          blocks={blocks}
          readOnly={readOnly}
          setQuestion={setQuestion}
          setSurveyForm={setSurveyForm}
          errors={errors}
        />
      )}

      {/* {JSON.stringify(blockQuestion)} */}
    </div>
  );
};

export default Question;
